// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   Contactos del cliente para avisos por correo.

   Ocupa el ancho completo bajo la rejilla de tres columnas: no es una lista
   más, es configuracion que decide a quien de FUERA se le escribe. Ponerla como
   cuarta columna la habria dejado del mismo tamano que "Loads", y su contenido
   -direccion, etiqueta, estado y preferencias- no cabe en ese ancho sin partirse.
   ========================================================================== */
.NotificationContactsCard_card__RL1Yz {
  /* Va ARRIBA de la rejilla de columnas, no debajo: las tres columnas crecen con
     el volumen del cliente y dejaban esta seccion fuera de vista. Lo que se
     revisa al abrir la ficha va antes de lo que se busca. */
  margin-bottom: 16px;
  padding: 18px 20px 20px;
}

.NotificationContactsCard_head__LiPTQ {
  margin-bottom: 14px;
}
.NotificationContactsCard_title__b4P8z {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--dylo-text);
}
.NotificationContactsCard_sub__3zwLK {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
  color: var(--dylo-muted);
  max-width: 76ch;
}

/* ----------------------------- Alta de un buzon --------------------------- */
.NotificationContactsCard_addRow__ke1CO {
  display: grid;
  grid-template-columns: minmax(220px, 2fr) minmax(180px, 1.4fr) auto;
  gap: 8px;
  align-items: center;
}
.NotificationContactsCard_addBtn__sVhoQ {
  white-space: nowrap;
}
/* El aviso de que guardar no manda nada va debajo del formulario y en gris:
   es una aclaracion, no una advertencia. Pintarlo en naranja haria parecer que
   algo salio mal al capturar. */
.NotificationContactsCard_addHint__vahx4 {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.5;
  color: var(--dylo-muted);
  max-width: 80ch;
}

.NotificationContactsCard_empty__t2rmV {
  margin: 14px 0 0;
  font-size: 12.5px;
  color: var(--dylo-muted);
}

/* --------------------------------- Lista ---------------------------------- */
.NotificationContactsCard_list__HDzdy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 14px;
}
.NotificationContactsCard_row__3px4A {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 11px 13px;
  border: 1px solid var(--dylo-border);
  border-radius: 8px;
  background: var(--dylo-surface-2, transparent);
}
.NotificationContactsCard_rowMain__zmNG- {
  min-width: 0;
  flex: 1 1;
}
.NotificationContactsCard_rowHead__WxnLs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.NotificationContactsCard_email__kvOEK {
  font-size: 13px;
  font-weight: 500;
  color: var(--dylo-text);
  word-break: break-all;
}
.NotificationContactsCard_label__k2tUx {
  font-size: 11px;
  color: var(--dylo-muted);
  padding: 1px 7px;
  border: 1px solid var(--dylo-border);
  border-radius: 5px;
}

/* ------------------------------- Los estados -------------------------------
   Cuatro tonos porque son cuatro acciones distintas. \`unsubscribed\` NO es rojo:
   no es una averia, es una decision del cliente que se respeta. Rojo lo haria
   ver como algo que hay que arreglar, y lo que hay que hacer es dejarlo en paz.
   ------------------------------------------------------------------------- */
.NotificationContactsCard_badge__khvcT {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  padding: 2px 7px;
  border-radius: 5px;
  white-space: nowrap;
}
.NotificationContactsCard_badge_active__cMV2o {
  color: #2e9e5b;
  background: color-mix(in srgb, #2e9e5b 14%, transparent);
  border: 1px solid color-mix(in srgb, #2e9e5b 40%, transparent);
}
.NotificationContactsCard_badge_pending__\\+lMJV {
  color: var(--dylo-muted);
  background: color-mix(in srgb, var(--dylo-muted) 12%, transparent);
  border: 1px solid var(--dylo-border);
}
.NotificationContactsCard_badge_unsubscribed__IrcnT {
  color: #8a8f98;
  background: color-mix(in srgb, #8a8f98 12%, transparent);
  border: 1px solid color-mix(in srgb, #8a8f98 32%, transparent);
}
.NotificationContactsCard_badge_bounced__CKoa1 {
  color: #d9534f;
  background: color-mix(in srgb, #d9534f 12%, transparent);
  border: 1px solid color-mix(in srgb, #d9534f 38%, transparent);
}

/* Invitacion viva vs caducada: la primera es informacion (gris), la segunda
   pide accion (naranja). */
.NotificationContactsCard_hintTag__69tj6 {
  font-size: 10.5px;
  color: var(--dylo-muted);
}
.NotificationContactsCard_warnTag__OL15h {
  font-size: 10.5px;
  color: var(--dylo-warning, #e0a44a);
}

.NotificationContactsCard_reason__rUQKV {
  margin: 6px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--dylo-muted);
}

/* ---------------------------- Preferencias --------------------------------- */
.NotificationContactsCard_expander__o8DQ9 {
  margin-top: 6px;
  padding: 0;
  border: none;
  background: none;
  color: var(--dylo-accent, #4a9ee0);
  font-size: 11.5px;
  cursor: pointer;
}
.NotificationContactsCard_expander__o8DQ9:hover {
  text-decoration: underline;
}
.NotificationContactsCard_prefs__78OI3 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 9px;
  padding-top: 9px;
  border-top: 1px dashed var(--dylo-border);
}
.NotificationContactsCard_check__WruvJ {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--dylo-text);
  cursor: pointer;
}
.NotificationContactsCard_check__WruvJ input {
  cursor: pointer;
}
.NotificationContactsCard_prefMeta__zM4-P {
  font-size: 11px;
  color: var(--dylo-muted);
}

/* ------------------------------- Acciones --------------------------------- */
.NotificationContactsCard_rowActions__OUDmL {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
}
.NotificationContactsCard_actionBtn__TRbv2 {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border: 1px solid var(--dylo-border);
  border-radius: 6px;
  background: transparent;
  color: var(--dylo-text);
  font-size: 11.5px;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 140ms ease, background 140ms ease;
}
.NotificationContactsCard_actionBtn__TRbv2:hover:not(:disabled) {
  border-color: var(--dylo-accent, #4a9ee0);
  background: color-mix(in srgb, var(--dylo-accent, #4a9ee0) 10%, transparent);
}
.NotificationContactsCard_actionBtn__TRbv2:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ------------------------------ Respuesta ---------------------------------- */
.NotificationContactsCard_feedback__\\+\\+1WM {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-bottom: 12px;
  padding: 8px 11px;
  border-radius: 7px;
  font-size: 12px;
  line-height: 1.5;
}
.NotificationContactsCard_fbOk__JzB-2 {
  color: #2e9e5b;
  background: color-mix(in srgb, #2e9e5b 10%, transparent);
  border: 1px solid color-mix(in srgb, #2e9e5b 30%, transparent);
}
.NotificationContactsCard_fbBad__XVkYP {
  color: var(--dylo-warning, #e0a44a);
  background: color-mix(in srgb, var(--dylo-warning, #e0a44a) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-warning, #e0a44a) 34%, transparent);
}

@media (max-width: 720px) {
  /* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): con \`1fr\` la columna no baja del ancho mínimo de un campo, que en el
     iPhone es más ancho que en Chromium (lo que le pasaba al login). */
  .NotificationContactsCard_addRow__ke1CO {
    grid-template-columns: minmax(0, 1fr);
  }
  .NotificationContactsCard_row__3px4A {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/ClientDetail/components/NotificationContactsCard.module.css"],"names":[],"mappings":"AAAA;;;;;;;+EAO+E;AAC/E;EACE;;4DAE0D;EAC1D,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mEAAmE;EACnE,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;gCAEgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,SAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;8EAI8E;AAC9E;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,wBAAwB;EACxB,kEAAkE;EAClE,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;;AAEA;2BAC2B;AAC3B;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,yCAAyC;EACzC,4EAA4E;AAC9E;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,mCAAmC;EACnC,6EAA6E;EAC7E,mFAAmF;AACrF;;AAEA;EACE;uEACqE;EACrE;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* =============================================================================\n   Contactos del cliente para avisos por correo.\n\n   Ocupa el ancho completo bajo la rejilla de tres columnas: no es una lista\n   más, es configuracion que decide a quien de FUERA se le escribe. Ponerla como\n   cuarta columna la habria dejado del mismo tamano que \"Loads\", y su contenido\n   -direccion, etiqueta, estado y preferencias- no cabe en ese ancho sin partirse.\n   ========================================================================== */\n.card {\n  /* Va ARRIBA de la rejilla de columnas, no debajo: las tres columnas crecen con\n     el volumen del cliente y dejaban esta seccion fuera de vista. Lo que se\n     revisa al abrir la ficha va antes de lo que se busca. */\n  margin-bottom: 16px;\n  padding: 18px 20px 20px;\n}\n\n.head {\n  margin-bottom: 14px;\n}\n.title {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.sub {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.55;\n  color: var(--dylo-muted);\n  max-width: 76ch;\n}\n\n/* ----------------------------- Alta de un buzon --------------------------- */\n.addRow {\n  display: grid;\n  grid-template-columns: minmax(220px, 2fr) minmax(180px, 1.4fr) auto;\n  gap: 8px;\n  align-items: center;\n}\n.addBtn {\n  white-space: nowrap;\n}\n/* El aviso de que guardar no manda nada va debajo del formulario y en gris:\n   es una aclaracion, no una advertencia. Pintarlo en naranja haria parecer que\n   algo salio mal al capturar. */\n.addHint {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  line-height: 1.5;\n  color: var(--dylo-muted);\n  max-width: 80ch;\n}\n\n.empty {\n  margin: 14px 0 0;\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n}\n\n/* --------------------------------- Lista ---------------------------------- */\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 14px;\n}\n.row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 11px 13px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 8px;\n  background: var(--dylo-surface-2, transparent);\n}\n.rowMain {\n  min-width: 0;\n  flex: 1;\n}\n.rowHead {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.email {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--dylo-text);\n  word-break: break-all;\n}\n.label {\n  font-size: 11px;\n  color: var(--dylo-muted);\n  padding: 1px 7px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 5px;\n}\n\n/* ------------------------------- Los estados -------------------------------\n   Cuatro tonos porque son cuatro acciones distintas. `unsubscribed` NO es rojo:\n   no es una averia, es una decision del cliente que se respeta. Rojo lo haria\n   ver como algo que hay que arreglar, y lo que hay que hacer es dejarlo en paz.\n   ------------------------------------------------------------------------- */\n.badge {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  padding: 2px 7px;\n  border-radius: 5px;\n  white-space: nowrap;\n}\n.badge_active {\n  color: #2e9e5b;\n  background: color-mix(in srgb, #2e9e5b 14%, transparent);\n  border: 1px solid color-mix(in srgb, #2e9e5b 40%, transparent);\n}\n.badge_pending {\n  color: var(--dylo-muted);\n  background: color-mix(in srgb, var(--dylo-muted) 12%, transparent);\n  border: 1px solid var(--dylo-border);\n}\n.badge_unsubscribed {\n  color: #8a8f98;\n  background: color-mix(in srgb, #8a8f98 12%, transparent);\n  border: 1px solid color-mix(in srgb, #8a8f98 32%, transparent);\n}\n.badge_bounced {\n  color: #d9534f;\n  background: color-mix(in srgb, #d9534f 12%, transparent);\n  border: 1px solid color-mix(in srgb, #d9534f 38%, transparent);\n}\n\n/* Invitacion viva vs caducada: la primera es informacion (gris), la segunda\n   pide accion (naranja). */\n.hintTag {\n  font-size: 10.5px;\n  color: var(--dylo-muted);\n}\n.warnTag {\n  font-size: 10.5px;\n  color: var(--dylo-warning, #e0a44a);\n}\n\n.reason {\n  margin: 6px 0 0;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: var(--dylo-muted);\n}\n\n/* ---------------------------- Preferencias --------------------------------- */\n.expander {\n  margin-top: 6px;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--dylo-accent, #4a9ee0);\n  font-size: 11.5px;\n  cursor: pointer;\n}\n.expander:hover {\n  text-decoration: underline;\n}\n.prefs {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 9px;\n  padding-top: 9px;\n  border-top: 1px dashed var(--dylo-border);\n}\n.check {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--dylo-text);\n  cursor: pointer;\n}\n.check input {\n  cursor: pointer;\n}\n.prefMeta {\n  font-size: 11px;\n  color: var(--dylo-muted);\n}\n\n/* ------------------------------- Acciones --------------------------------- */\n.rowActions {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-shrink: 0;\n}\n.actionBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border: 1px solid var(--dylo-border);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--dylo-text);\n  font-size: 11.5px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 140ms ease, background 140ms ease;\n}\n.actionBtn:hover:not(:disabled) {\n  border-color: var(--dylo-accent, #4a9ee0);\n  background: color-mix(in srgb, var(--dylo-accent, #4a9ee0) 10%, transparent);\n}\n.actionBtn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ------------------------------ Respuesta ---------------------------------- */\n.feedback {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin-bottom: 12px;\n  padding: 8px 11px;\n  border-radius: 7px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n.fbOk {\n  color: #2e9e5b;\n  background: color-mix(in srgb, #2e9e5b 10%, transparent);\n  border: 1px solid color-mix(in srgb, #2e9e5b 30%, transparent);\n}\n.fbBad {\n  color: var(--dylo-warning, #e0a44a);\n  background: color-mix(in srgb, var(--dylo-warning, #e0a44a) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-warning, #e0a44a) 34%, transparent);\n}\n\n@media (max-width: 720px) {\n  /* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): con `1fr` la columna no baja del ancho mínimo de un campo, que en el\n     iPhone es más ancho que en Chromium (lo que le pasaba al login). */\n  .addRow {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .row {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `NotificationContactsCard_card__RL1Yz`,
	"head": `NotificationContactsCard_head__LiPTQ`,
	"title": `NotificationContactsCard_title__b4P8z`,
	"sub": `NotificationContactsCard_sub__3zwLK`,
	"addRow": `NotificationContactsCard_addRow__ke1CO`,
	"addBtn": `NotificationContactsCard_addBtn__sVhoQ`,
	"addHint": `NotificationContactsCard_addHint__vahx4`,
	"empty": `NotificationContactsCard_empty__t2rmV`,
	"list": `NotificationContactsCard_list__HDzdy`,
	"row": `NotificationContactsCard_row__3px4A`,
	"rowMain": `NotificationContactsCard_rowMain__zmNG-`,
	"rowHead": `NotificationContactsCard_rowHead__WxnLs`,
	"email": `NotificationContactsCard_email__kvOEK`,
	"label": `NotificationContactsCard_label__k2tUx`,
	"badge": `NotificationContactsCard_badge__khvcT`,
	"badge_active": `NotificationContactsCard_badge_active__cMV2o`,
	"badge_pending": `NotificationContactsCard_badge_pending__+lMJV`,
	"badge_unsubscribed": `NotificationContactsCard_badge_unsubscribed__IrcnT`,
	"badge_bounced": `NotificationContactsCard_badge_bounced__CKoa1`,
	"hintTag": `NotificationContactsCard_hintTag__69tj6`,
	"warnTag": `NotificationContactsCard_warnTag__OL15h`,
	"reason": `NotificationContactsCard_reason__rUQKV`,
	"expander": `NotificationContactsCard_expander__o8DQ9`,
	"prefs": `NotificationContactsCard_prefs__78OI3`,
	"check": `NotificationContactsCard_check__WruvJ`,
	"prefMeta": `NotificationContactsCard_prefMeta__zM4-P`,
	"rowActions": `NotificationContactsCard_rowActions__OUDmL`,
	"actionBtn": `NotificationContactsCard_actionBtn__TRbv2`,
	"feedback": `NotificationContactsCard_feedback__++1WM`,
	"fbOk": `NotificationContactsCard_fbOk__JzB-2`,
	"fbBad": `NotificationContactsCard_fbBad__XVkYP`
};
export default ___CSS_LOADER_EXPORT___;
